import { render, staticRenderFns } from "./onLineVip.vue?vue&type=template&id=4b9a8b63&scoped=true"
import script from "./onLineVip.vue?vue&type=script&lang=js"
export * from "./onLineVip.vue?vue&type=script&lang=js"
import style0 from "./onLineVip.vue?vue&type=style&index=0&id=4b9a8b63&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b9a8b63",
  null
  
)

export default component.exports